export enum ObjectSortProperties {
    DISPLAY_NAME = 'Name',
    TYPE = 'Type',
}

export interface ObjectSort {
    by: ObjectSortProperties;
    reverse: boolean;
}
